import React from 'react';
import { Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

interface AddLevelButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const AddLevelButton: React.FC<AddLevelButtonProps> = ({
  onClick,
  disabled = false,
}) => {
  return (
    <Button
      variant="outlined"
      startIcon={<AddIcon />}
      onClick={onClick}
      disabled={disabled}
      sx={{ textTransform: 'none' }}
    >
      Add Level
    </Button>
  );
};
